
define('text!views/shared/header/authorizedpartnerheader.html',[],function () { return '\r\n<div id="header-logged-out">\r\n\r\n\t<div class="nav-links js-nav-links"></div>\r\n\r\n\t<div class="user-links js-user-links"></div>\r\n\r\n</div>\r\n';});

